/** The `leadSource` every lead flow submits, as a Site Builder page. */
const LEAD_SOURCE = "sitebuilder-page";

export { LEAD_SOURCE };
